/* 🤖 this file was generated by svg-to-ts */
export const siriusFunnel: {
  name: 'funnel';
  data: string;
} = {
  name: 'funnel',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.947 3.75h16.106a1.5 1.5 0 0 1 1.108 2.511l-.001.002-6.158 6.776-.002.002v5.303a1.49 1.49 0 0 1-.675 1.257l-2.997 1.995-.003.002A1.5 1.5 0 0 1 9 20.353v-7.312l-.002-.002L2.84 6.263V6.26a1.5 1.5 0 0 1-.373-.767l1.48-.244.002.002 6.156 6.775c.256.276.398.64.395 1.017v7.302l2.997-1.995.003-.002v-5.305c-.002-.377.139-.74.395-1.017l6.156-6.775.002-.002H3.947l-1.48.244a1.5 1.5 0 0 1 1.48-1.744" fill="currentColor"/></svg>`
};
